module.exports = __webpack_public_path__ + "img/SEL50F14GM.6d63024a.jpg";